module.exports = require("@pb/kit-component-icon-button");